import { render } from "./PdfViewer.vue?vue&type=template&id=88b5e000&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=88b5e000&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b5e000"]])

export default __exports__